/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weight: NonNullable<unknown> }} Model_Premium_CostInputs */

const en_model_premium_cost = /** @type {(inputs: Model_Premium_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weight} credits per call`)
};

const id_model_premium_cost = /** @type {(inputs: Model_Premium_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weight} kredit per panggilan`)
};

/**
* | output |
* | --- |
* | "{weight} credits per call" |
*
* @param {Model_Premium_CostInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_premium_cost = /** @type {((inputs: Model_Premium_CostInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Premium_CostInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_premium_cost(inputs)
	return en_model_premium_cost(inputs)
});